module.exports = __webpack_public_path__ + "img/symbol_2.aabd2bec.png";